import { subCollectionsNames } from 'utils/constants/graphs';
import {
  GET_CLIENT_PROGRESS_IMAGES_SUCCESS,
  GET_CLIENT_PROGRESS_IMAGES_APPEND_SUCCESS,
  GET_CLIENT_PROGRESS_IMAGES_ERROR,
  GET_CLIENT_PROGRESS_IMAGES_SUMMARY_SUCCESS,
  GET_GRAPHS_DATA_SUCCEED,
  GET_GRAPHS_DATA_ERROR,
  GET_CLIENT_TRACK_SUCCEED,
  GET_CLIENT_TRACK_ERROR,
  RESET_GRAPHS_LOADING_STATE,
  LOADING_CLIENT_TRACK_STATE
} from './Types';

const INITIAL_STATE = {
  progresImages: [],
  graphsData: {},
  clientTrackObj: {},
  loadingCount: subCollectionsNames.length,
  loadingClientTrack: false
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === GET_CLIENT_PROGRESS_IMAGES_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === GET_CLIENT_PROGRESS_IMAGES_SUCCESS) {
    return {
      ...state,
      progressImages: action.payload.images,
      lastImage: action.payload.last,
      error: null
    };
  } else if (action.type === GET_CLIENT_PROGRESS_IMAGES_APPEND_SUCCESS) {
    return {
      ...state,
      progressImages: [...state.progressImages, ...action.payload.images],
      lastImage: action.payload.last
    };
  } else if (action.type === GET_CLIENT_PROGRESS_IMAGES_SUMMARY_SUCCESS) {
    return { ...state, progressImagesSummary: action.payload };
  } else if (action.type === GET_GRAPHS_DATA_SUCCEED) {
    return {
      ...state,
      loadingCount: state.loadingCount < subCollectionsNames.length ?
                      state.loadingCount+1 :
                      state.loadingCount,
      graphsData: { ...state.graphsData, ...action.payload }
    };
  } else if (action.type === GET_GRAPHS_DATA_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === GET_CLIENT_TRACK_SUCCEED) {
    return { ...state, clientTrackObj: action.payload, loadingClientTrack: false };
  } else if (action.type === GET_CLIENT_TRACK_ERROR) {
    return { ...state, error: action.payload, loadingClientTrack: false };
  } else if (action.type === RESET_GRAPHS_LOADING_STATE) {
    return { ...state, loadingCount: 0 };
  } else if (action.type === LOADING_CLIENT_TRACK_STATE) {
    return { ...state, loadingClientTrack: true };
  } else {
    return state;
  }
}
